<div class="sof">
  <app-fh-select
    [formControl]="selectControl"
    [label]="label"
    [options]="options"
  ></app-fh-select>

  <one-input
    *ngIf="isOtherSelected"
    class="sof__other"
    type="text"
    [formControl]="otherTextControl"
    [placeholder]="placeholder"
  ></one-input>
</div>
